
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
let $47b379a135ac7ff8$export$6bc2f4a51ae720ac = (repositoryUrl, version)=>{
    // white on black (classic for light theme)
    return `<a href="${repositoryUrl}" title="v${version}" class="github-corner" aria-label="View source on GitHub"><svg width="80" height="80" viewBox="0 0 250 250" style="fill:#151513; color:#fff; position: absolute; top: 0; border: 0; right: 0;" aria-hidden="true"><path d="M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"></path><path d="M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2" fill="currentColor" style="transform-origin: 130px 106px;" class="octo-arm"></path><path d="M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z" fill="currentColor" class="octo-body"></path></svg></a><style>.github-corner:hover .octo-arm{animation:octocat-wave 560ms ease-in-out}@keyframes octocat-wave{0%,100%{transform:rotate(0)}20%,60%{transform:rotate(-25deg)}40%,80%{transform:rotate(10deg)}}@media (max-width:500px){.github-corner:hover .octo-arm{animation:none}.github-corner .octo-arm{animation:octocat-wave 560ms ease-in-out}}</style>`;
};


var $5105b3b40fcb4a1e$exports = {};
(function(root, factory) {
    if ($5105b3b40fcb4a1e$exports) $5105b3b40fcb4a1e$exports = factory();
    else root.nearley = factory();
})($5105b3b40fcb4a1e$exports, function() {
    function Rule(name, symbols, postprocess) {
        this.id = ++Rule.highestId;
        this.name = name;
        this.symbols = symbols; // a list of literal | regex class | nonterminal
        this.postprocess = postprocess;
        return this;
    }
    Rule.highestId = 0;
    Rule.prototype.toString = function(withCursorAt) {
        var symbolSequence = typeof withCursorAt === "undefined" ? this.symbols.map(getSymbolShortDisplay).join(' ') : this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(' ') + " \u25CF " + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(' ');
        return this.name + " \u2192 " + symbolSequence;
    };
    // a State is a rule at a position from a given starting point in the input stream (reference)
    function State(rule, dot, reference, wantedBy) {
        this.rule = rule;
        this.dot = dot;
        this.reference = reference;
        this.data = [];
        this.wantedBy = wantedBy;
        this.isComplete = this.dot === rule.symbols.length;
    }
    State.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    };
    State.prototype.nextState = function(child) {
        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
        state.left = this;
        state.right = child;
        if (state.isComplete) {
            state.data = state.build();
            // Having right set here will prevent the right state and its children
            // form being garbage collected
            state.right = undefined;
        }
        return state;
    };
    State.prototype.build = function() {
        var children = [];
        var node = this;
        do {
            children.push(node.right.data);
            node = node.left;
        }while (node.left);
        children.reverse();
        return children;
    };
    State.prototype.finish = function() {
        if (this.rule.postprocess) this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
    };
    function Column(grammar, index) {
        this.grammar = grammar;
        this.index = index;
        this.states = [];
        this.wants = {}; // states indexed by the non-terminal they expect
        this.scannable = []; // list of states that expect a token
        this.completed = {}; // states that are nullable
    }
    Column.prototype.process = function(nextColumn) {
        var states = this.states;
        var wants = this.wants;
        var completed = this.completed;
        for(var w = 0; w < states.length; w++){
            var state = states[w];
            if (state.isComplete) {
                state.finish();
                if (state.data !== Parser.fail) {
                    // complete
                    var wantedBy = state.wantedBy;
                    for(var i = wantedBy.length; i--;){
                        var left = wantedBy[i];
                        this.complete(left, state);
                    }
                    // special-case nullables
                    if (state.reference === this.index) {
                        // make sure future predictors of this rule get completed.
                        var exp = state.rule.name;
                        (this.completed[exp] = this.completed[exp] || []).push(state);
                    }
                }
            } else {
                // queue scannable states
                var exp = state.rule.symbols[state.dot];
                if (typeof exp !== 'string') {
                    this.scannable.push(state);
                    continue;
                }
                // predict
                if (wants[exp]) {
                    wants[exp].push(state);
                    if (completed.hasOwnProperty(exp)) {
                        var nulls = completed[exp];
                        for(var i = 0; i < nulls.length; i++){
                            var right = nulls[i];
                            this.complete(state, right);
                        }
                    }
                } else {
                    wants[exp] = [
                        state
                    ];
                    this.predict(exp);
                }
            }
        }
    };
    Column.prototype.predict = function(exp) {
        var rules = this.grammar.byName[exp] || [];
        for(var i = 0; i < rules.length; i++){
            var r = rules[i];
            var wantedBy = this.wants[exp];
            var s = new State(r, 0, this.index, wantedBy);
            this.states.push(s);
        }
    };
    Column.prototype.complete = function(left, right) {
        var copy = left.nextState(right);
        this.states.push(copy);
    };
    function Grammar(rules, start) {
        this.rules = rules;
        this.start = start || this.rules[0].name;
        var byName = this.byName = {};
        this.rules.forEach(function(rule) {
            if (!byName.hasOwnProperty(rule.name)) byName[rule.name] = [];
            byName[rule.name].push(rule);
        });
    }
    // So we can allow passing (rules, start) directly to Parser for backwards compatibility
    Grammar.fromCompiled = function(rules, start) {
        var lexer = rules.Lexer;
        if (rules.ParserStart) {
            start = rules.ParserStart;
            rules = rules.ParserRules;
        }
        var rules = rules.map(function(r) {
            return new Rule(r.name, r.symbols, r.postprocess);
        });
        var g = new Grammar(rules, start);
        g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
        return g;
    };
    function StreamLexer() {
        this.reset("");
    }
    StreamLexer.prototype.reset = function(data, state) {
        this.buffer = data;
        this.index = 0;
        this.line = state ? state.line : 1;
        this.lastLineBreak = state ? -state.col : 0;
    };
    StreamLexer.prototype.next = function() {
        if (this.index < this.buffer.length) {
            var ch = this.buffer[this.index++];
            if (ch === '\n') {
                this.line += 1;
                this.lastLineBreak = this.index;
            }
            return {
                value: ch
            };
        }
    };
    StreamLexer.prototype.save = function() {
        return {
            line: this.line,
            col: this.index - this.lastLineBreak
        };
    };
    StreamLexer.prototype.formatError = function(token, message) {
        // nb. this gets called after consuming the offending token,
        // so the culprit is index-1
        var buffer = this.buffer;
        if (typeof buffer === 'string') {
            var lines = buffer.split("\n").slice(Math.max(0, this.line - 5), this.line);
            var nextLineBreak = buffer.indexOf('\n', this.index);
            if (nextLineBreak === -1) nextLineBreak = buffer.length;
            var col = this.index - this.lastLineBreak;
            var lastLineDigits = String(this.line).length;
            message += " at line " + this.line + " col " + col + ":\n\n";
            message += lines.map(function(line, i) {
                return pad(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
            }, this).join("\n");
            message += "\n" + pad("", lastLineDigits + col) + "^\n";
            return message;
        } else return message + " at index " + (this.index - 1);
        function pad(n, length) {
            var s = String(n);
            return Array(length - s.length + 1).join(" ") + s;
        }
    };
    function Parser(rules, start, options) {
        if (rules instanceof Grammar) {
            var grammar = rules;
            var options = start;
        } else var grammar = Grammar.fromCompiled(rules, start);
        this.grammar = grammar;
        // Read options
        this.options = {
            keepHistory: false,
            lexer: grammar.lexer || new StreamLexer
        };
        for(var key in options || {})this.options[key] = options[key];
        // Setup lexer
        this.lexer = this.options.lexer;
        this.lexerState = undefined;
        // Setup a table
        var column = new Column(grammar, 0);
        var table = this.table = [
            column
        ];
        // I could be expecting anything.
        column.wants[grammar.start] = [];
        column.predict(grammar.start);
        // TODO what if start rule is nullable?
        column.process();
        this.current = 0; // token index
    }
    // create a reserved token for indicating a parse fail
    Parser.fail = {};
    Parser.prototype.feed = function(chunk) {
        var lexer = this.lexer;
        lexer.reset(chunk, this.lexerState);
        var token;
        while(true){
            try {
                token = lexer.next();
                if (!token) break;
            } catch (e) {
                // Create the next column so that the error reporter
                // can display the correctly predicted states.
                var nextColumn = new Column(this.grammar, this.current + 1);
                this.table.push(nextColumn);
                var err = new Error(this.reportLexerError(e));
                err.offset = this.current;
                err.token = e.token;
                throw err;
            }
            // We add new states to table[current+1]
            var column = this.table[this.current];
            // GC unused states
            if (!this.options.keepHistory) delete this.table[this.current - 1];
            var n = this.current + 1;
            var nextColumn = new Column(this.grammar, n);
            this.table.push(nextColumn);
            // Advance all tokens that expect the symbol
            var literal = token.text !== undefined ? token.text : token.value;
            var value = lexer.constructor === StreamLexer ? token.value : token;
            var scannable = column.scannable;
            for(var w = scannable.length; w--;){
                var state = scannable[w];
                var expect = state.rule.symbols[state.dot];
                // Try to consume the token
                // either regex or literal
                if (expect.test ? expect.test(value) : expect.type ? expect.type === token.type : expect.literal === literal) {
                    // Add it
                    var next = state.nextState({
                        data: value,
                        token: token,
                        isToken: true,
                        reference: n - 1
                    });
                    nextColumn.states.push(next);
                }
            }
            // Next, for each of the rules, we either
            // (a) complete it, and try to see if the reference row expected that
            //     rule
            // (b) predict the next nonterminal it expects by adding that
            //     nonterminal's start state
            // To prevent duplication, we also keep track of rules we have already
            // added
            nextColumn.process();
            // If needed, throw an error:
            if (nextColumn.states.length === 0) {
                // No states at all! This is not good.
                var err = new Error(this.reportError(token));
                err.offset = this.current;
                err.token = token;
                throw err;
            }
            // maybe save lexer state
            if (this.options.keepHistory) column.lexerState = lexer.save();
            this.current++;
        }
        if (column) this.lexerState = lexer.save();
        // Incrementally keep track of results
        this.results = this.finish();
        // Allow chaining, for whatever it's worth
        return this;
    };
    Parser.prototype.reportLexerError = function(lexerError) {
        var tokenDisplay, lexerMessage;
        // Planning to add a token property to moo's thrown error
        // even on erroring tokens to be used in error display below
        var token = lexerError.token;
        if (token) {
            tokenDisplay = "input " + JSON.stringify(token.text[0]) + " (lexer error)";
            lexerMessage = this.lexer.formatError(token, "Syntax error");
        } else {
            tokenDisplay = "input (lexer error)";
            lexerMessage = lexerError.message;
        }
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportError = function(token) {
        var tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== undefined ? token.value : token);
        var lexerMessage = this.lexer.formatError(token, "Syntax error");
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
        var lines = [];
        lines.push(lexerMessage);
        var lastColumnIndex = this.table.length - 2;
        var lastColumn = this.table[lastColumnIndex];
        var expectantStates = lastColumn.states.filter(function(state) {
            var nextSymbol = state.rule.symbols[state.dot];
            return nextSymbol && typeof nextSymbol !== "string";
        });
        if (expectantStates.length === 0) {
            lines.push('Unexpected ' + tokenDisplay + '. I did not expect any more input. Here is the state of my parse table:\n');
            this.displayStateStack(lastColumn.states, lines);
        } else {
            lines.push('Unexpected ' + tokenDisplay + '. Instead, I was expecting to see one of the following:\n');
            // Display a "state stack" for each expectant state
            // - which shows you how this state came to be, step by step.
            // If there is more than one derivation, we only display the first one.
            var stateStacks = expectantStates.map(function(state) {
                return this.buildFirstStateStack(state, []) || [
                    state
                ];
            }, this);
            // Display each state that is expecting a terminal symbol next.
            stateStacks.forEach(function(stateStack) {
                var state = stateStack[0];
                var nextSymbol = state.rule.symbols[state.dot];
                var symbolDisplay = this.getSymbolDisplay(nextSymbol);
                lines.push('A ' + symbolDisplay + ' based on:');
                this.displayStateStack(stateStack, lines);
            }, this);
        }
        lines.push("");
        return lines.join("\n");
    };
    Parser.prototype.displayStateStack = function(stateStack, lines) {
        var lastDisplay;
        var sameDisplayCount = 0;
        for(var j = 0; j < stateStack.length; j++){
            var state = stateStack[j];
            var display = state.rule.toString(state.dot);
            if (display === lastDisplay) sameDisplayCount++;
            else {
                if (sameDisplayCount > 0) lines.push('    ^ ' + sameDisplayCount + ' more lines identical to this');
                sameDisplayCount = 0;
                lines.push('    ' + display);
            }
            lastDisplay = display;
        }
    };
    Parser.prototype.getSymbolDisplay = function(symbol) {
        return getSymbolLongDisplay(symbol);
    };
    /*
    Builds a the first state stack. You can think of a state stack as the call stack
    of the recursive-descent parser which the Nearley parse algorithm simulates.
    A state stack is represented as an array of state objects. Within a
    state stack, the first item of the array will be the starting
    state, with each successive item in the array going further back into history.

    This function needs to be given a starting state and an empty array representing
    the visited states, and it returns an single state stack.

    */ Parser.prototype.buildFirstStateStack = function(state, visited) {
        if (visited.indexOf(state) !== -1) // Found cycle, return null
        // to eliminate this path from the results, because
        // we don't know how to display it meaningfully
        return null;
        if (state.wantedBy.length === 0) return [
            state
        ];
        var prevState = state.wantedBy[0];
        var childVisited = [
            state
        ].concat(visited);
        var childResult = this.buildFirstStateStack(prevState, childVisited);
        if (childResult === null) return null;
        return [
            state
        ].concat(childResult);
    };
    Parser.prototype.save = function() {
        var column = this.table[this.current];
        column.lexerState = this.lexerState;
        return column;
    };
    Parser.prototype.restore = function(column) {
        var index = column.index;
        this.current = index;
        this.table[index] = column;
        this.table.splice(index + 1);
        this.lexerState = column.lexerState;
        // Incrementally keep track of results
        this.results = this.finish();
    };
    // nb. deprecated: use save/restore instead!
    Parser.prototype.rewind = function(index) {
        if (!this.options.keepHistory) throw new Error('set option `keepHistory` to enable rewinding');
        // nb. recall column (table) indicies fall between token indicies.
        //        col 0   --   token 0   --   col 1
        this.restore(this.table[index]);
    };
    Parser.prototype.finish = function() {
        // Return the possible parsings
        var considerations = [];
        var start = this.grammar.start;
        var column = this.table[this.table.length - 1];
        column.states.forEach(function(t) {
            if (t.rule.name === start && t.dot === t.rule.symbols.length && t.reference === 0 && t.data !== Parser.fail) considerations.push(t);
        });
        return considerations.map(function(c) {
            return c.data;
        });
    };
    function getSymbolLongDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return 'character matching ' + symbol;
            else if (symbol.type) return symbol.type + ' token';
            else if (symbol.test) return 'token matching ' + String(symbol.test);
            else throw new Error('Unknown symbol type: ' + symbol);
        }
    }
    function getSymbolShortDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return symbol.toString();
            else if (symbol.type) return '%' + symbol.type;
            else if (symbol.test) return '<' + String(symbol.test) + '>';
            else throw new Error('Unknown symbol type: ' + symbol);
        }
    }
    return {
        Parser: Parser,
        Grammar: Grammar,
        Rule: Rule
    };
});


var $1b70f3a77842b501$exports = {};
// Generated automatically by nearley, version unknown
// http://github.com/Hardmath123/nearley
(function() {
    function id(x) {
        return x[0];
    }
    var grammar = {
        Lexer: undefined,
        ParserRules: [
            {
                "name": "main",
                "symbols": [
                    "_",
                    "program",
                    "_"
                ],
                "postprocess": ([, program])=>program
            },
            {
                "name": "program$ebnf$1$subexpression$1$ebnf$1",
                "symbols": []
            },
            {
                "name": "program$ebnf$1$subexpression$1$ebnf$1$subexpression$1",
                "symbols": [
                    "__",
                    "expression"
                ]
            },
            {
                "name": "program$ebnf$1$subexpression$1$ebnf$1",
                "symbols": [
                    "program$ebnf$1$subexpression$1$ebnf$1",
                    "program$ebnf$1$subexpression$1$ebnf$1$subexpression$1"
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "program$ebnf$1$subexpression$1",
                "symbols": [
                    "expression",
                    "program$ebnf$1$subexpression$1$ebnf$1"
                ]
            },
            {
                "name": "program$ebnf$1",
                "symbols": [
                    "program$ebnf$1$subexpression$1"
                ],
                "postprocess": id
            },
            {
                "name": "program$ebnf$1",
                "symbols": [],
                "postprocess": function(d) {
                    return null;
                }
            },
            {
                "name": "program",
                "symbols": [
                    "program$ebnf$1"
                ],
                "postprocess": ([content])=>{
                    if (content === null) return [];
                    return [
                        content[0],
                        ...content[1].map(([, c])=>c)
                    ];
                }
            },
            {
                "name": "expression",
                "symbols": [
                    "expression_"
                ],
                "postprocess": ([[value]])=>value
            },
            {
                "name": "expression_",
                "symbols": [
                    "identifier"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "access"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "string"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "number"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "operation"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "assignment"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "functionassignment"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "codeblock"
                ]
            },
            {
                "name": "expression_",
                "symbols": [
                    "group"
                ]
            },
            {
                "name": "identifier$ebnf$1",
                "symbols": []
            },
            {
                "name": "identifier$ebnf$1",
                "symbols": [
                    "identifier$ebnf$1",
                    /[0-9A-Za-z_]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "identifier",
                "symbols": [
                    /[A-Za-z_]/,
                    "identifier$ebnf$1"
                ],
                "postprocess": ([first, rest])=>({
                        kind: "identifier",
                        name: first + rest.join("")
                    })
            },
            {
                "name": "access",
                "symbols": [
                    {
                        "literal": "."
                    },
                    "identifier"
                ],
                "postprocess": ([, { name: name }])=>({
                        kind: "access",
                        name: name
                    })
            },
            {
                "name": "string$ebnf$1",
                "symbols": []
            },
            {
                "name": "string$ebnf$1",
                "symbols": [
                    "string$ebnf$1",
                    "string_content"
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "string",
                "symbols": [
                    {
                        "literal": "\""
                    },
                    "string$ebnf$1",
                    {
                        "literal": "\""
                    }
                ],
                "postprocess": ([, value])=>({
                        kind: "litteral",
                        value: {
                            kind: "string",
                            value: value.join("")
                        }
                    })
            },
            {
                "name": "string_content",
                "symbols": [
                    /[^"\n\\]/
                ]
            },
            {
                "name": "string_content",
                "symbols": [
                    {
                        "literal": "\\"
                    },
                    /[ntr"\\]/
                ],
                "postprocess": ([, character])=>{
                    switch(character){
                        case "n":
                            return "\n";
                        case "t":
                            return "\t";
                        case "r":
                            return "\r";
                        case "\"":
                            return "\"";
                        case "\\":
                            return "\\";
                    }
                }
            },
            {
                "name": "number$subexpression$1",
                "symbols": [
                    {
                        "literal": "0"
                    }
                ]
            },
            {
                "name": "number$subexpression$1$ebnf$1",
                "symbols": []
            },
            {
                "name": "number$subexpression$1$ebnf$1",
                "symbols": [
                    "number$subexpression$1$ebnf$1",
                    /[0-9]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "number$subexpression$1",
                "symbols": [
                    /[1-9]/,
                    "number$subexpression$1$ebnf$1"
                ]
            },
            {
                "name": "number",
                "symbols": [
                    "number$subexpression$1"
                ],
                "postprocess": ([[head, body = []]])=>({
                        kind: "litteral",
                        value: {
                            kind: "number",
                            value: +(head + body.join(""))
                        }
                    })
            },
            {
                "name": "operation",
                "symbols": [
                    "operator",
                    "__",
                    "expression"
                ],
                "postprocess": ([[operator], , target])=>({
                        kind: "operation",
                        operator: operator,
                        target: target
                    })
            },
            {
                "name": "operator$string$1",
                "symbols": [
                    {
                        "literal": "="
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join('');
                }
            },
            {
                "name": "operator",
                "symbols": [
                    "operator$string$1"
                ]
            },
            {
                "name": "operator$string$2",
                "symbols": [
                    {
                        "literal": "!"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join('');
                }
            },
            {
                "name": "operator",
                "symbols": [
                    "operator$string$2"
                ]
            },
            {
                "name": "operator$string$3",
                "symbols": [
                    {
                        "literal": "<"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join('');
                }
            },
            {
                "name": "operator",
                "symbols": [
                    "operator$string$3"
                ]
            },
            {
                "name": "operator$string$4",
                "symbols": [
                    {
                        "literal": ">"
                    },
                    {
                        "literal": "="
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join('');
                }
            },
            {
                "name": "operator",
                "symbols": [
                    "operator$string$4"
                ]
            },
            {
                "name": "operator$string$5",
                "symbols": [
                    {
                        "literal": "<"
                    },
                    {
                        "literal": "<"
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join('');
                }
            },
            {
                "name": "operator",
                "symbols": [
                    "operator$string$5"
                ]
            },
            {
                "name": "operator$string$6",
                "symbols": [
                    {
                        "literal": ">"
                    },
                    {
                        "literal": ">"
                    }
                ],
                "postprocess": function joiner(d) {
                    return d.join('');
                }
            },
            {
                "name": "operator",
                "symbols": [
                    "operator$string$6"
                ]
            },
            {
                "name": "operator",
                "symbols": [
                    /[-+*/%<>&^|]/
                ]
            },
            {
                "name": "assignment",
                "symbols": [
                    {
                        "literal": "="
                    },
                    "_",
                    "identifier"
                ],
                "postprocess": ([, , { name: name }])=>({
                        kind: "assignment",
                        target: name
                    })
            },
            {
                "name": "functionassignment",
                "symbols": [
                    {
                        "literal": ":"
                    },
                    "_",
                    "identifier"
                ],
                "postprocess": ([, , { name: name }])=>({
                        kind: "functionassignment",
                        target: name
                    })
            },
            {
                "name": "codeblock$macrocall$2",
                "symbols": [
                    "_",
                    "program",
                    "_"
                ]
            },
            {
                "name": "codeblock$macrocall$1",
                "symbols": [
                    {
                        "literal": "{"
                    },
                    "codeblock$macrocall$2",
                    {
                        "literal": "}"
                    }
                ]
            },
            {
                "name": "codeblock",
                "symbols": [
                    "codeblock$macrocall$1"
                ],
                "postprocess": ([[, [, program]]])=>({
                        kind: "litteral",
                        value: {
                            kind: "codeblock",
                            value: program
                        }
                    })
            },
            {
                "name": "group$macrocall$2",
                "symbols": [
                    "_",
                    "program",
                    "_"
                ]
            },
            {
                "name": "group$macrocall$1",
                "symbols": [
                    {
                        "literal": "("
                    },
                    "group$macrocall$2",
                    {
                        "literal": ")"
                    }
                ]
            },
            {
                "name": "group",
                "symbols": [
                    "group$macrocall$1"
                ],
                "postprocess": ([[, [, program]]])=>({
                        kind: "group",
                        program: program
                    })
            },
            {
                "name": "_$ebnf$1",
                "symbols": []
            },
            {
                "name": "_$ebnf$1",
                "symbols": [
                    "_$ebnf$1",
                    /[ \t\n]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "_$ebnf$2",
                "symbols": []
            },
            {
                "name": "_$ebnf$2$subexpression$1$ebnf$1",
                "symbols": []
            },
            {
                "name": "_$ebnf$2$subexpression$1$ebnf$1",
                "symbols": [
                    "_$ebnf$2$subexpression$1$ebnf$1",
                    /[ \t\n]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "_$ebnf$2$subexpression$1",
                "symbols": [
                    "comment",
                    "_$ebnf$2$subexpression$1$ebnf$1"
                ]
            },
            {
                "name": "_$ebnf$2",
                "symbols": [
                    "_$ebnf$2",
                    "_$ebnf$2$subexpression$1"
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "_",
                "symbols": [
                    "_$ebnf$1",
                    "_$ebnf$2"
                ]
            },
            {
                "name": "__$ebnf$1",
                "symbols": [
                    /[ \t\n]/
                ]
            },
            {
                "name": "__$ebnf$1",
                "symbols": [
                    "__$ebnf$1",
                    /[ \t\n]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__$ebnf$2",
                "symbols": []
            },
            {
                "name": "__$ebnf$2$subexpression$1$ebnf$1",
                "symbols": []
            },
            {
                "name": "__$ebnf$2$subexpression$1$ebnf$1",
                "symbols": [
                    "__$ebnf$2$subexpression$1$ebnf$1",
                    /[ \t\n]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__$ebnf$2$subexpression$1",
                "symbols": [
                    "comment",
                    "__$ebnf$2$subexpression$1$ebnf$1"
                ]
            },
            {
                "name": "__$ebnf$2",
                "symbols": [
                    "__$ebnf$2",
                    "__$ebnf$2$subexpression$1"
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__",
                "symbols": [
                    "__$ebnf$1",
                    "__$ebnf$2"
                ]
            },
            {
                "name": "__$ebnf$3$subexpression$1$ebnf$1",
                "symbols": []
            },
            {
                "name": "__$ebnf$3$subexpression$1$ebnf$1",
                "symbols": [
                    "__$ebnf$3$subexpression$1$ebnf$1",
                    /[ \t\n]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__$ebnf$3$subexpression$1",
                "symbols": [
                    "comment",
                    "__$ebnf$3$subexpression$1$ebnf$1"
                ]
            },
            {
                "name": "__$ebnf$3",
                "symbols": [
                    "__$ebnf$3$subexpression$1"
                ]
            },
            {
                "name": "__$ebnf$3$subexpression$2$ebnf$1",
                "symbols": []
            },
            {
                "name": "__$ebnf$3$subexpression$2$ebnf$1",
                "symbols": [
                    "__$ebnf$3$subexpression$2$ebnf$1",
                    /[ \t\n]/
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__$ebnf$3$subexpression$2",
                "symbols": [
                    "comment",
                    "__$ebnf$3$subexpression$2$ebnf$1"
                ]
            },
            {
                "name": "__$ebnf$3",
                "symbols": [
                    "__$ebnf$3",
                    "__$ebnf$3$subexpression$2"
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "__",
                "symbols": [
                    "__$ebnf$3"
                ]
            },
            {
                "name": "comment$ebnf$1",
                "symbols": []
            },
            {
                "name": "comment$ebnf$1",
                "symbols": [
                    "comment$ebnf$1",
                    /./
                ],
                "postprocess": function arrpush(d) {
                    return d[0].concat([
                        d[1]
                    ]);
                }
            },
            {
                "name": "comment",
                "symbols": [
                    {
                        "literal": "#"
                    },
                    "comment$ebnf$1",
                    {
                        "literal": "\n"
                    }
                ]
            }
        ],
        ParserStart: "main"
    };
    if (typeof $1b70f3a77842b501$exports !== 'undefined') $1b70f3a77842b501$exports = grammar;
    else window.grammar = grammar;
})();


let $9fd44832378de894$export$ac74a19039455e37 = (text)=>{
    let index = 0;
    return {
        read (count) {
            index += count;
            return text.slice(index - count, index);
        }
    };
};


function $b96f7a69ad7a27d3$export$128beb349d296c49(programString, write) {
    let parser = new (0, (/*@__PURE__*/$parcel$interopDefault($5105b3b40fcb4a1e$exports))).Parser((0, (/*@__PURE__*/$parcel$interopDefault($1b70f3a77842b501$exports))));
    parser.feed(programString);
    let program = parser.results[0];
    if (!program) throw "The program doesn't parse";
    return {
        run (stdinString) {
            let runtime = {
                reader: (0, $9fd44832378de894$export$ac74a19039455e37)(stdinString),
                write: write,
                stack: []
            };
            $b96f7a69ad7a27d3$var$runProgram(program, runtime, $b96f7a69ad7a27d3$export$f0bb796dc665d20d, true);
        },
        runeval (rt, frame) {
            $b96f7a69ad7a27d3$var$runProgram(program, rt, frame, false);
        }
    };
}
function $b96f7a69ad7a27d3$export$8f3495e22775e76c(value) {
    return [
        "string",
        "number",
        "boolean"
    ].includes(value.kind);
}
let $b96f7a69ad7a27d3$export$f0bb796dc665d20d = {
    data: {
        printstack: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                rt.write("<" + JSON.stringify(rt.stack, null, 2) + ">");
            }
        },
        true: {
            kind: "boolean",
            value: true
        },
        false: {
            kind: "boolean",
            value: false
        },
        stdin: {
            kind: "native",
            value: {
                data: {
                    read: {
                        kind: "nativefunction",
                        value: (rt, frame)=>{
                            let textArray = [];
                            let chunk = rt.reader.read(1000);
                            textArray.push(chunk);
                            while(chunk.length === 1000){
                                chunk = rt.reader.read(1000);
                                textArray.push(chunk);
                            }
                            rt.stack.push({
                                kind: "string",
                                value: textArray.join("")
                            });
                        }
                    }
                }
            }
        },
        stdout: {
            kind: "native",
            value: {
                data: {
                    write: {
                        kind: "nativefunction",
                        value: (rt, frame)=>{
                            let entry = rt.stack.pop();
                            if (!$b96f7a69ad7a27d3$export$8f3495e22775e76c(entry)) throw new TypeError(`Expected a scalar but got a ${entry.kind}`);
                            rt.write(entry.value.toString());
                        }
                    }
                }
            }
        },
        output: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let entry = rt.stack.pop();
                if (!$b96f7a69ad7a27d3$export$8f3495e22775e76c(entry)) throw new TypeError(`Expected a scalar but got a ${entry.kind}`);
                rt.write(entry.value.toString() + "\n");
            }
        },
        input: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let valueArray = [];
                let c = rt.reader.read(1);
                while(c !== "\n" && c !== ""){
                    valueArray.push(c);
                    c = rt.reader.read(1);
                }
                rt.stack.push({
                    kind: "string",
                    value: valueArray.join("")
                });
            }
        },
        number: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let entry = rt.stack.pop();
                if (!$b96f7a69ad7a27d3$export$8f3495e22775e76c(entry)) throw new TypeError(`Expected a scalar value but got ${entry.kind}`);
                rt.stack.push({
                    kind: "number",
                    value: +entry.value
                });
            }
        },
        array: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                rt.stack.push({
                    kind: "array",
                    value: []
                });
            }
        },
        object: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                rt.stack.push({
                    kind: "object",
                    value: {}
                });
            }
        },
        loop: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let last = rt.stack.pop();
                if (last.kind !== "codeblock") throw TypeError(`Expected a codeblock but got a ${last.kind}`);
                for(let k = 0; k < 1000; k++)$b96f7a69ad7a27d3$var$runProgram(last.value, rt, frame, false);
            }
        },
        if: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let [ifyes, ifno, testresult] = rt.stack.splice(-3, 3);
                if (ifyes.kind !== "codeblock" || ifno.kind !== "codeblock" || testresult.kind !== "boolean") throw new TypeError(`Expected two codeblocks and a boolean but got ${ifyes.kind}, ${ifno.kind} and ${testresult.kind}`);
                $b96f7a69ad7a27d3$var$runProgram(testresult.value ? ifyes.value : ifno.value, rt, frame, false);
            }
        },
        run: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let codeblock = rt.stack.pop();
                if (codeblock.kind !== "codeblock") throw new TypeError(`Expected a codeblock but got a ${codeblock.kind}`);
                $b96f7a69ad7a27d3$var$runProgram(codeblock.value, rt, frame, true);
            }
        },
        eval: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let text = rt.stack.pop();
                if (text.kind !== "string") throw new TypeError(`Expected a string but got a ${text.kind}`);
                $b96f7a69ad7a27d3$export$128beb349d296c49(text.value, rt.write).runeval(rt, frame);
            }
        },
        while: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let [body, test] = rt.stack.splice(-2, 2);
                if (body.kind !== "codeblock" || test.kind !== "codeblock") throw new TypeError(`Expected two codeblocks but got ${body.kind} and ${test.kind}`);
                let k = 0;
                while($b96f7a69ad7a27d3$var$runProgram(test.value, rt, frame, false), rt.stack.pop().value && k < 1000){
                    $b96f7a69ad7a27d3$var$runProgram(body.value, rt, frame, false);
                    k += 1;
                }
            }
        },
        toJson: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let entry = rt.stack.pop();
                rt.stack.push({
                    kind: "string",
                    value: JSON.stringify(entry, (k, v)=>v.value)
                });
            }
        },
        fromJson: {
            kind: "nativefunction",
            value: (rt, frame)=>{
                let body = rt.stack.pop();
                if (body.kind !== "string") throw new TypeError(`fromJson expected a string but it got a ${body.kind}`);
                rt.stack.push(JSON.parse(body.value, (k, v)=>({
                        kind: Array.isArray(v) ? "array" : typeof v,
                        value: v
                    })));
            }
        }
    }
};
let $b96f7a69ad7a27d3$export$1eab2041c1a732a = {
    push: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let [value, array] = rt.stack.splice(-2, 2);
            array.value.push(value);
        }
    },
    pop: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let array = rt.stack.pop();
            rt.stack.push(array.value.pop());
        }
    },
    unshift: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let [value, array] = rt.stack.splice(-2, 2);
            array.value.unshift(value);
        }
    },
    shift: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let array = rt.stack.pop();
            rt.stack.push(array.value.shift());
        }
    },
    get: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let [index, array] = rt.stack.splice(-2, 2);
            if (index.kind !== "number") throw TypeError(`expected a number index, got a ${index.kind}`);
            rt.stack.push(array.value[index.value]);
        }
    },
    set: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let [value, index, array] = rt.stack.splice(-3, 3);
            if (index.kind !== "number") throw TypeError(`expected a number index, got a ${index.kind}`);
            array.value[index.value] = value;
        }
    }
};
let $b96f7a69ad7a27d3$export$e4a249a929fb81b2 = {
    get: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let [key, obj] = rt.stack.splice(-2, 2);
            rt.stack.push(obj.value[key.value]);
        }
    },
    set: {
        kind: "nativefunction",
        value: (rt, frame)=>{
            let [value, key, obj] = rt.stack.splice(-3, 3);
            obj.value[key.value] = value;
        }
    }
};
/**
 * Run the given broccoli code, possibly inside a new frame
 * @param program
 * @param runtime
 * @param frame
 * @param createNewFrame
 */ function $b96f7a69ad7a27d3$var$runProgram(program, runtime, frame, createNewFrame) {
    if (createNewFrame) frame = {
        parent: frame,
        data: {}
    };
    program.forEach((expression)=>{
        $b96f7a69ad7a27d3$var$runExpression(expression, runtime, frame);
    });
}
/**
 * Execute the given expression according to its kind
 *
 * @param expression The expression to run
 * @param runtime The runtime
 * @param frame The current frame
 */ function $b96f7a69ad7a27d3$var$runExpression(expression, runtime, frame) {
    let { stack: stack } = runtime;
    let entry;
    let previous;
    switch(expression.kind){
        case "access":
            previous = stack.pop();
            if (previous.kind === "native") entry = previous.value.data[expression.name];
            else if (previous.kind === "array") {
                entry = $b96f7a69ad7a27d3$export$1eab2041c1a732a[expression.name];
                stack.push(previous);
            } else if (previous.kind === "object") {
                entry = $b96f7a69ad7a27d3$export$e4a249a929fb81b2[expression.name];
                stack.push(previous);
            } else throw new Error("unhandled access case");
            if (entry === undefined) throw new ReferenceError(`unrecognized identifier ${expression.name}`);
            $b96f7a69ad7a27d3$var$runEntry(entry, runtime, frame);
            break;
        case "assignment":
            frame.data[expression.target] = stack.pop();
            break;
        case "functionassignment":
            previous = stack.pop();
            if (previous.kind !== "codeblock") throw new TypeError(`Expected a codeblock but got a ${previous.kind}`);
            frame.data[expression.target] = {
                kind: "function",
                value: previous.value
            };
            break;
        case "litteral":
            stack.push(expression.value);
            break;
        case "group":
            $b96f7a69ad7a27d3$var$runProgram(expression.program, runtime, frame, true);
            break;
        case "identifier":
            let { name: name } = expression;
            entry = $b96f7a69ad7a27d3$var$frameLookup(frame, name);
            $b96f7a69ad7a27d3$var$runEntry(entry, runtime, frame);
            break;
        case "operation":
            let operator = $b96f7a69ad7a27d3$var$operatorMap[expression.operator];
            let left = stack.pop();
            $b96f7a69ad7a27d3$var$runExpression(expression.target, runtime, frame);
            let right = stack.pop();
            stack.push(operator(left, right));
            break;
    }
}
/**
 * runEntry performs the action related to the given entry, be it running a
 * function or just adding it as a value to the stack.
 *
 * @param entry The entry to run
 * @param runtime The runtime context
 * @param frame The current frame
 */ function $b96f7a69ad7a27d3$var$runEntry(entry, runtime, frame) {
    if (entry.kind === "function") $b96f7a69ad7a27d3$var$runProgram(entry.value, runtime, frame, true);
    else if (entry.kind === "nativefunction") entry.value(runtime, frame);
    else runtime.stack.push(entry);
}
function $b96f7a69ad7a27d3$var$frameLookup(initialFrame, name) {
    let frame = initialFrame;
    let result = frame.data[name];
    let k = 0;
    let recursionLimit = 100;
    while(result === undefined && frame.parent && k < recursionLimit){
        frame = frame.parent;
        result = frame.data[name];
        k += 1;
    }
    if (result === undefined) {
        if (k >= recursionLimit) throw new Error("too much codeblock recursion");
        else throw new ReferenceError(`unrecognized identifier ${name}`);
    }
    return result;
}
function $b96f7a69ad7a27d3$var$numericOperator(f) {
    return (a, b)=>{
        if (a.kind !== "number" || b.kind !== "number") throw new TypeError(`expected number inputs but got ${a.kind} and ${b.kind}`);
        return {
            kind: "number",
            value: f(a.value, b.value)
        };
    };
}
function $b96f7a69ad7a27d3$var$comparisonOperator(f) {
    return (a, b)=>{
        if (a.kind !== "number" || b.kind !== "number") throw new TypeError(`expected numbers, got ${a.kind} and ${b.kind} in comparision operator`);
        return {
            kind: "boolean",
            value: f(a.value, b.value)
        };
    };
}
let $b96f7a69ad7a27d3$var$operatorMap = {
    "*": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a * b),
    "/": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a / b),
    "%": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>(a % b + b) % b),
    "+": (a, b)=>{
        if (![
            "string",
            "number"
        ].includes(a.kind) || ![
            "string",
            "number"
        ].includes(b.kind)) throw new TypeError(`got incompatible types ${a.kind} and ${b.kind} in addition operator`);
        let kind = "string";
        if (a.kind === "number" && b.kind === "number") kind = "number";
        return {
            kind: kind,
            value: a.value + b.value
        };
    },
    "-": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a - b),
    "<<": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a << b),
    ">>": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a >> b),
    "&": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a & b),
    "^": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a ^ b),
    "|": $b96f7a69ad7a27d3$var$numericOperator((a, b)=>a | b),
    "<": $b96f7a69ad7a27d3$var$comparisonOperator((a, b)=>a < b),
    "<=": $b96f7a69ad7a27d3$var$comparisonOperator((a, b)=>a <= b),
    ">": $b96f7a69ad7a27d3$var$comparisonOperator((a, b)=>a > b),
    ">=": $b96f7a69ad7a27d3$var$comparisonOperator((a, b)=>a >= b),
    "==": (a, b)=>{
        return {
            kind: "boolean",
            value: a.kind === b.kind && a.value === b.value
        };
    },
    "!=": (a, b)=>{
        return {
            kind: "boolean",
            value: a.kind !== b.kind || a.value !== b.value
        };
    }
};


function $b7811c3c04a63dc4$export$1d81801f981b61e(a) {
    let b = a[0].split("\n");
    if (b[0].length === 0) b.splice(0, 1);
    return b.map((line)=>line.trimStart()).join("\n");
}


let $79a3fbaf3c1dcc13$export$dcf56692ee8d91e5 = {
    "Hello world": [
        `"Hello World!" output`,
        ""
    ],
    "Precedence": [
        `3 + 3 * 3 output`,
        ""
    ],
    "Factorial": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        input number = a
        1 = b
        { a * b = b a - 1 = a }
        { a > 0 }
        while

        b output`,
        "4"
    ],
    "Truth machine": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        { { 1 stdout .write } { true } while }
        { 0 output }
        input number == 1
        if
        `,
        "0"
    ],
    "Copy input lines on output": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        input
        { output input }
        { = a a a }
        while
        `,
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        abc
        defg
        hijkl
        `
    ],
    "Copy the whole input on output": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        stdin .read
        stdout .write
        `,
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        abc
        defg

        _
        `
    ],
    "Run a code block": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        { input output } = copy
        copy run
        `,
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        content line one
        content line two
        `
    ],
    "Create and invoke a function": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        { "Hello world!" output } : hello
        hello
        `,
        ""
    ],
    "Create and manipulate objects and arrays": [
        (0, $b7811c3c04a63dc4$export$1d81801f981b61e)`
        # find all the methods available at:
        # https://github.com/mathieucaroff/broccoli/blob/743cad01/src/broccoli.ts#L236
        array = a
        0 a .push
        10 a .push
        20 a .push
        a toJson output

        object = b
        2 "foo" b .set
        4 "bar" b .set
        b toJson output
        `,
        ""
    ]
};


var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"broccoli\",\"version\":\"1.0.0\",\"license\":\"NTP\",\"repository\":{\"url\":\"https://github.com/mathieucaroff/broccoli\"},\"scripts\":{\"check\":\"tsc --noEmit\",\"checkwatch\":\"tsc --noEmit --watch\",\"build\":\"parcel build src/index.html --dist-dir public\",\"mcabuild\":\"parcel build src/index.html --public-url broccoli.d\",\"serve\":\"parcel src/index.html\"},\"dependencies\":{\"nearley\":\"^2.20.1\"},\"devDependencies\":{\"@parcel/transformer-inline-string\":\"2.3.2\",\"@parcel/transformer-yaml\":\"2.3.2\",\"@types/nearley\":\"^2.11.2\",\"parcel\":\"^2.3.2\",\"parcel-transformer-nearley\":\"^1.0.4\",\"specimen-test\":\"^0.1.4\",\"typescript\":\"^4.6.2\"}}");


let $ad2bcec7a0192558$var$div = document.createElement("div");
$ad2bcec7a0192558$var$div.innerHTML = (0, $47b379a135ac7ff8$export$6bc2f4a51ae720ac)((0, $8f13b60c0ee5b277$exports.repository).url, (0, $8f13b60c0ee5b277$exports.version));
document.body.appendChild($ad2bcec7a0192558$var$div);
let $ad2bcec7a0192558$var$select = document.getElementById("exampleSelect");
let $ad2bcec7a0192558$var$program = document.getElementById("program");
let $ad2bcec7a0192558$var$stdin = document.getElementById("stdin");
let $ad2bcec7a0192558$var$stderr = document.getElementById("stderr");
let $ad2bcec7a0192558$var$stdout = document.getElementById("stdout");
Object.keys((0, $79a3fbaf3c1dcc13$export$dcf56692ee8d91e5)).forEach((key)=>{
    let option = document.createElement("option");
    option.textContent = key;
    option.value = key;
    $ad2bcec7a0192558$var$select.appendChild(option);
});
$ad2bcec7a0192558$var$select.addEventListener("change", ()=>{
    [$ad2bcec7a0192558$var$program.value, $ad2bcec7a0192558$var$stdin.value] = (0, $79a3fbaf3c1dcc13$export$dcf56692ee8d91e5)[$ad2bcec7a0192558$var$select.value];
    $ad2bcec7a0192558$var$program.rows = Math.max($ad2bcec7a0192558$var$program.rows, $ad2bcec7a0192558$var$program.value.split("\n").length);
    $ad2bcec7a0192558$var$stdin.rows = $ad2bcec7a0192558$var$stdin.value.split("\n").length;
    $ad2bcec7a0192558$var$update();
});
function $ad2bcec7a0192558$var$handleChange() {
    setTimeout($ad2bcec7a0192558$var$update, 1);
}
function $ad2bcec7a0192558$var$update() {
    if ($ad2bcec7a0192558$var$program.value !== (0, $79a3fbaf3c1dcc13$export$dcf56692ee8d91e5)[$ad2bcec7a0192558$var$select.value]?.[0]) $ad2bcec7a0192558$var$select.value = "-";
    $ad2bcec7a0192558$var$stderr.innerText = "";
    try {
        $ad2bcec7a0192558$var$stdout.innerText = "";
        (0, $b96f7a69ad7a27d3$export$128beb349d296c49)($ad2bcec7a0192558$var$program.value, (v)=>$ad2bcec7a0192558$var$stdout.innerText += v).run($ad2bcec7a0192558$var$stdin.value);
    } catch (error) {
        let errorText = "" + error;
        let errorSet;
        if (errorText.startsWith("Error: Syntax error at line ")) {
            errorText = errorText.replace(/ based on:(\n    .*)+/g, "");
            errorSet = new Set(errorText.split("\n"));
            errorText = Array.from(errorSet).join("\n");
        }
        $ad2bcec7a0192558$var$stderr.innerText = errorText;
    }
}
$ad2bcec7a0192558$var$update();
$ad2bcec7a0192558$var$program.addEventListener("input", $ad2bcec7a0192558$var$handleChange, true);
$ad2bcec7a0192558$var$stdin.addEventListener("input", $ad2bcec7a0192558$var$handleChange, true);


//# sourceMappingURL=path0.4aa2c007.js.map
